import { ChangeDetectorRef, Component, ElementRef, HostBinding, OnInit, ViewChild } from '@angular/core';

import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';

import { filter, from, map, toArray } from 'rxjs';

import axios from 'src/app/Service/axios';

import { DataService } from 'src/app/Service/data.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { animate, state, style, transition, trigger } from "@angular/animations";

import { AudioRecordingService } from 'src/app/Service/audio-recording.service';

import { DomSanitizer } from '@angular/platform-browser';

import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'carList',

  templateUrl: './car_list.Component.html',

  styles: [`

    .modal-body{
        
        direction: rtl;
    }

    .section {
        overflow: auto;
        max-height:76vh;
    }

    #excel-car-list {
        overflow-x: auto;
        white-space: nowrap;

    }

    div.position-relative>label {
            background-color: white;
            position: absolute;
            right: 17px;
            top: -9px;
            padding: 0 10px;
            font-size: 14px;
            z-index: 2;
        }

        div.position-relative>input {
            color: navy;

        }

        div.position-relative>input:disabled {

            background-color: white !important;

        }

        .audio-icon{
          position: absolute;
          z-index: 1;
          top: 11px;
          right: 12px;
          border: none;
        }

        #Export_Excel {
    overflow-x: auto;
    white-space: nowrap;

}

  
  `],

  animations: [
    trigger('slideDown', [
      state(
        'hide',
        style({
          height: '0',
          opacity: '0',
          overflow: 'hidden',
          padding: '0',
        })
      ),
      state(
        'show',
        style({
          height: '*',
          opacity: '1',
          overflow: 'visible',
          padding: '1rem'
        })
      ),
      transition('hide <=> show', animate('300ms ease-in-out'))
    ])
  ]

})

export class CarListComponent implements OnInit {

  fileName = 'ExcelSheet.xlsx';

  carNumber: number = 0;

  car: any;

  deviceInfo: any;

  filterCar: any = [];

  bSelectAll: boolean = false;

  bEnableEditCar: boolean = false;

  bCollapsible: boolean = true;

  bSimpleSearch: boolean = false;

  showFilter: boolean = false;

  bSendSMS: boolean = false;

  bSendPush: boolean = false;

  bSendPayamak: boolean = false;

  bUpdate_ValidDate: boolean = false;

  optionsSelect = '';

  iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

  carType: any;

  carWork: any;

  lst_MobileDomain: any[] = [];

  lst_UserManager = [];

  gpsType: any = [];

  searchOptionState: 'show' | 'hide' = 'show';

  isAudioRecording: boolean = false;

  bTaxiLon: boolean = false;

  audioRecordedTime: any;

  audioBlobUrl: any = '';

  audioSrcUrl: any = '';

  audioBlob: any;

  audioName: any;

  lst_MobileUsage: any[] = [];

  lst_Plate: any[] = [];

  lst_MobileGroup: any[] = [];

  lst_TaxiLon_Driver: any = [];

  serchModel = new FormGroup({

    serchType: new FormControl(),

    txt: new FormControl(),

  });

  mdlSearch: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    tiMobileType: new FormControl(-1),

    iMobileDomain: new FormControl(-1),

    tiGPSType: new FormControl(-1),

    strFullName: new FormControl(''),

    strCellNo: new FormControl(''),

    strMobile: new FormControl(''),

    iCode: new FormControl(-1),

    iGPS: new FormControl(-1),

    strVehicleNo: new FormControl(''),

    strPersonnelID: new FormControl(''),

    iSKm: new FormControl(''),

    iEKm: new FormControl(''),

    iSYearConstruction: new FormControl(''),

    iEYearConstruction: new FormControl(''),

    strSTime: new FormControl(''),

    strETime: new FormControl(''),

    tiFuelType: new FormControl('-1'),

    tiPassenger: new FormControl(''),

    strVehicleType: new FormControl(''),

    tiMobileUsage: new FormControl('-1'),

    tiPlateType: new FormControl('-1'),

    tiMobileGroup: new FormControl('-1'),

  })

  mdl_SMS: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    lststrUnitIDs: new FormControl('', Validators.required),

    strSMS: new FormControl('', Validators.required),

    bGPRS: new FormControl(true),

  });

  mdl_PUSH: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    lststrUnitIDs: new FormControl('', Validators.required),

    strTitle: new FormControl('', Validators.required),

    strMessage: new FormControl(''),

    strVoice: new FormControl(''),

    iPushType: new FormControl(''),

    tiType: new FormControl('4'),

    bSMS: new FormControl(false),

  });

  mdl_UpdateValidDate: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    lststrUnitIDs: new FormControl('', Validators.required),

    strValidDate: new FormControl(''),

    iChargingFee: new FormControl(''),

  })

  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    private route: ActivatedRoute,

    private deviceService: DeviceDetectorService,

    private dataService: DataService,

    public otherService: OtherService,

    public gurdService: GurdServiceService,

    private formBuilder: FormBuilder,

    private audioRecordingService: AudioRecordingService,

    private sanitizer: DomSanitizer,

    private ref: ChangeDetectorRef,


  ) {

    this.audioRecordingService.recordingFailed().subscribe(() => {

      this.isAudioRecording = false;

      this.ref.detectChanges();

    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {

      this.audioRecordedTime = time;

      if (time == '00:21') {

        this.stopAudioRecording();

        this.notifyService.showError('حده اکثر زمان ضبط صدا 20 ثانیه است')

      }

      this.ref.detectChanges();

    });

    this.route.url.subscribe((segment) => {

      if (segment[0].path == "manage-drivers") {

        this.bTaxiLon = true;

      }

    })

  }

  ngOnInit(): void {

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    var data = window.localStorage.getItem("menu") as any;

    this.bEnableEditCar = JSON.parse(this.gurdService.decrypt(data)).bEnableEditCar;

    this.bSendSMS = JSON.parse(this.gurdService.decrypt(data)).bSendSMS2MobilesUser;

    this.bSendPush = JSON.parse(this.gurdService.decrypt(data)).bSendPush2MobilesUser;

    this.bSendPayamak = JSON.parse(this.gurdService.decrypt(data)).bSendSMS2Driver; // bSMS

    this.bUpdate_ValidDate = JSON.parse(this.gurdService.decrypt(data)).bFleetyar_UpdateValidDate;

    if (Number(this.iSystemUser) == -2) {

      this.getCar();

      this.bSimpleSearch = true;

      this.searchOptionState = 'hide';

    }

    else {

      this.getItem()

    }

    this.serchModel.controls['serchType'].setValue('1');

    this.serchModel.controls['txt'].setValue(this.dataService.carListTxtSearch);

    if (this.dataService.carListTxtSearch) this.serch();

    this.deviceInfo = this.deviceService.isDesktop();

    // 

    this.audioRecordingService.getRecordedBlob().subscribe((data) => {

      var base64 = this.blobToBase64(data.blob);

      base64.then((result: any) => {

        result = result.replace('data:audio/wav;base64,', '')

        this.mdl_PUSH.get('strVoice')?.setValue(result);

      });

      this.audioBlob = data.blob;

      this.audioName = data.title;

      this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));

      this.ref.detectChanges();

    });

  }

  toggleSearchOption(): void {

    this.searchOptionState = this.searchOptionState === 'hide' ? 'show' : 'hide';
  }

  getCar = async () => {

    //? دریافت لیست خودروها همراه با تصویر

    // if (!this.dataService.carList) {

    //   this.dataService.getCarList().then((resp: any) => {

    //     this.car = this.dataService.carList;

    //     this.filterCar = this.dataService.carList;

    //     this.carNumber = this.dataService.carList.length;

    //   });

    // }

    // else {

    //   this.car = this.dataService.carList;

    //   this.filterCar = this.dataService.carList;

    //   this.carNumber = this.dataService.carList.length;

    // }

    //? دریافت لیست خودروها بدون تصویر

    if (!this.dataService.carList_New) {

      this.dataService.getCarList_New().then((resp: any) => {

        this.otherService.Showspinner()

        this.car = this.dataService.carList_New;

        this.filterCar = this.dataService.carList_New;

        this.carNumber = this.dataService.carList_New.length;

        this.otherService.nonespinner();

        // scroll to right

        setTimeout(() => {

          this.scrollContainer.nativeElement.scrollLeft = this.scrollContainer.nativeElement.scrollWidth;

        }, 10);

      });

    }

    else {

      this.otherService.Showspinner()

      this.car = this.dataService.carList_New;

      this.filterCar = this.dataService.carList_New;

      this.carNumber = this.dataService.carList_New.length;

      this.otherService.nonespinner();

      // scroll to right

      setTimeout(() => {

        this.scrollContainer.nativeElement.scrollLeft = this.scrollContainer.nativeElement.scrollWidth;

      }, 10);

    }

  };

  updateMobileDomain = async () => {

    if (!this.filterCar.length) return this.notifyService.showError('خودرویی موجود نیست!')

    const selectedMobileDomain = from(this.filterCar).pipe(filter((el: any) => el?.bChosen && el.bChosen), map((el: any) => el.strUnitID), toArray());

    selectedMobileDomain.subscribe(async (data) => {

      const lstUnitID = data;

      if (!lstUnitID.length) return this.notifyService.showError('لیست انتخابی شما خالی می باشد');

      this.otherService.Showspinner();

      var model = {

        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      }

      let resp = await axios.post(`MobileDomain_ListUserAccess`, model);

      if (resp.data.ISSessionExpired == true) {

        this.otherService.removeLocalStorage();

        this.router.navigate(['login']);

        this.router.navigate(['login'], { queryParams: { error: '13' } });


        return;

      }

      this.otherService.nonespinner();

      var options = '';

      this.optionsSelect = '';

      var result = JSON.parse(resp.data)

      result.unshift({ iMobileDomain: -1, strComment: 'انتخاب کنید' })

      result.forEach(function (item: any) {

        options += '<option value="' + item.iMobileDomain + '">' + item.strComment + '</option>';

      });

      this.optionsSelect = options;

      var selectElement = $('<select class="form-control" id="mySelect"></select>').html(this.optionsSelect);

      var inputElement = $('<input class="form-control mb-2" placeholder="نام حوزه خدمت را جستجو کنید" id="myInput">');

      $.confirm({

        title: ``,

        content: inputElement.add(selectElement),

        type: 'blue',

        buttons: {

          ok: {

            text: "ثبت",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              var selectedValue = $('#mySelect').val();

              if (selectedValue == '-1') return this.notifyService.showError('لطفا نام حوزه را مشخص کنید !!');

              var model = {

                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

                iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

                lstUnitID: lstUnitID,

                iMobileDomain: selectedValue,

              }

              this.otherService.Showspinner()

              let res = JSON.parse((await axios.post(`Mobiles_UpdateMobileDomain`, model)).data.toString());

              this.otherService.nonespinner();

              if (res.ISSessionExpired == true) {

                this.otherService.removeLocalStorage();

                // this.router.navigate(['login']);

                this.router.navigate(['login'], { queryParams: { error: '14' } });

                return;

              }

              if (res.iResult == 0) return this.notifyService.showError(res.strError);

              res = !res.length ? res : res[0];

              if (res.iResult == 0) return this.notifyService.showError(res.strError);

              else {

                await this.dataService.getCarList().then((resp: any) => {

                  this.car = this.dataService.carList;

                  this.filterCar = this.dataService.carList;

                  this.carNumber = this.dataService.carList.length;

                });

                return this.notifyService.showSuccess('با موفقیت ویرایش شد')

              }

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

      inputElement.on('input', () => {

        var inputValue = inputElement.val().toString().trim().toLowerCase();

        this.filterSelectOptions(inputValue, result);

      });

    })

  }

  searchCar = async () => {

    this.otherService.Showspinner();

    this.mdlSearch.get('strSTime')?.setValue($("#strSTime").val());

    this.mdlSearch.get('strETime')?.setValue($("#strETime").val());

    var model = this.mdlSearch.value;

    if (this.mdlSearch.get('iSKm')?.value.trim() == '') model.iSKm = -1;

    if (this.mdlSearch.get('iEKm')?.value.trim() == '') model.iEKm = -1;

    if (this.mdlSearch.get('tiPassenger')?.value.trim() == '') model.tiPassenger = -1;

    if (this.mdlSearch.get('iSYearConstruction')?.value.trim() == '') model.iSYearConstruction = -1;

    if (this.mdlSearch.get('iEYearConstruction')?.value.trim() == '') model.iEYearConstruction = -1;

    model = this.otherService.stringNumberToNumber(this.mdlSearch.value);

    let resp: any = await axios.post(`FleetYar_Car_Search`, model);

    this.otherService.nonespinner();

    if (resp.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '15' } });

      return;

    }

    let res = JSON.parse(resp.data.toString());

    if (res.iResult == 0) return this.notifyService.showError(res.strError);

    this.car = res;

    this.filterCar = res;

    this.carNumber = res.length;

    this.bCollapsible = false;

    this.toggleSearchOption();

    setTimeout(() => {

      this.scrollContainer.nativeElement.scrollLeft = this.scrollContainer.nativeElement.scrollWidth;

    }, 10);

  }

  getItem = async () => {

    this.otherService.Showspinner()

    const resp = await axios.post(`GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`, {});

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.lst_MobileDomain = res;

    // ------------------------------------------------------

    let res_2 = await axios.post(`GetMobileType`);

    this.carWork = res_2.data;

    // ------------------------------------------------------

    let res_4 = await axios.post(`GetGPSType`);

    this.carType = res_4.data;

    // ------------------------------------------------------

    let res_5 = await axios.post(`GetGPS`);

    this.gpsType = res_5.data;

    this.gpsType.unshift({ iGPS: -1, strComment: 'انتخاب کنید' })

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);

    // ---------------------------------------------------------------

    const resp6 = await axios.post(`MobileUsage_List`);

    let res6 = JSON.parse(resp6.data);

    this.lst_MobileUsage = res6;

    // ----------------------------------------------------------------

    const resp7 = await axios.post(`PlateType_List`);

    let res7 = JSON.parse(resp7.data);

    this.lst_Plate = res7;

    // ----------------------------------------------------------------

    const resp8 = await axios.post(`GetMobileGroup`);

    let res8 = JSON.parse(resp8.data);

    this.lst_MobileGroup = res8;

    // ----------------------------------------------------------------

    this.otherService.nonespinner()

  };

  openSMS_User() {

    if (!this.filterCar.length) return this.notifyService.showError('خودرویی موجود نیست!')

    const selectedUser = from(this.filterCar).pipe(filter((el: any) => el?.bChosen && el.bChosen), map((el: any) => el.strUnitID), toArray());

    selectedUser.subscribe(async (data) => {

      const lstUnitID = data;

      if (!lstUnitID.length) return this.notifyService.showError('لیست انتخابی شما خالی می باشد');

      this.mdl_SMS.patchValue({

        lststrUnitIDs: lstUnitID,

        strSMS: '',

        bGPRS: true

      })


      $("#SmsModal").modal('show')

    })

  }

  sendSMS_4Users = async () => {

    if (this.mdl_SMS.invalid) return this.notifyService.showError('متن پیامک را وارد کنید');

    else {

      this.otherService.Showspinner();

      var model = this.otherService.stringNumberToNumber(this.mdl_SMS.value);

      let response = await axios.post(`SendSMS2MobilesSelected`, model);

      this.otherService.nonespinner();

      let res = JSON.parse(response.data.toString())

      if (res.iResult == 0) return this.notifyService.showError(res.strError);

      this.notifyService.showSuccess('پیامک با موفقیت ارسال شد');

      this.mdl_SMS.patchValue({

        lststrUnitIDs: '',

        strSMS: '',

        bGPRS: true,


      })

      $("#SmsModal").modal('hide')


    }

  }

  serch() {

    var model = this.serchModel.value;

    this.dataService.carListTxtSearch = model.txt;

    this.filterCar = this.car?.filter(function (el: any) {

      return el.strFullName2.includes(`${model.txt}`) ||

        el.strUnitID.includes(`${model.txt}`) ||

        el.strVehicleNo.includes(`${model.txt}`) ||

        el.strMobileDomain_strComment.includes(`${model.txt}`) ||

        el.strCellNo.includes(`${model.txt}`) ||

        el.strPersonnelID.includes(`${model.txt}`) ||

        el.strMobile.includes(`${model.txt}`)

    });

    this.carNumber = this.filterCar.length;

    setTimeout(() => {

      this.scrollContainer.nativeElement.scrollLeft = this.scrollContainer.nativeElement.scrollWidth;

    }, 10);

  }

  guid() {
    this.otherService.guid(12);
  }

  sortBy(input: any) {

    if (this.filterCar.length > 0) {

      this.filterCar.sort((a: any, b: any) => {

        if (input == 0) {
          return (b.strPersonnelID != null ? b.strPersonnelID : Infinity) - (a.strPersonnelID != null ? a.strPersonnelID : Infinity)
        }

        if (input == 1) {
          var textA = a.strFullName.toUpperCase();
          var textB = b.strFullName.toUpperCase();
        }

        if (input == 2) {
          return new Date(a.strDefinationDate) as any - (new Date(b.strDefinationDate) as any);
        }

        if (input == 3) {

          return (new Date(a.strValidDate) as any) - (new Date(b.strValidDate) as any);

        }

        if (input == 4) {
          var textA = a.strMobileDomain_strComment.toUpperCase();
          var textB = b.strMobileDomain_strComment.toUpperCase();
        }

        if (input == 5) {
          var textA = (a.strDate + a.strTime).toUpperCase();
          var textB = (b.strDate + b.strTime).toUpperCase();
        }

        return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;

        // if (textA > textB)
        //   return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
        // if (textA < textB)
        //   return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        // return

      })

    }
    
  }

  exportexcel(id: any): void {

    if (!this.filterCar.length) return this.notifyService.showError('خودرویی موجود نیست!');
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  changeRoute(item: any) {

    let URL = `/carList/carInfo/${item.strUnitID}`;

    window.open(URL, '_blank')
  }

  onCheckbox_Car(event: any, index: number, target?: 'select-all') {

    if (target) {

      if (!this.bSelectAll) {

        this.filterCar.forEach((a: any) => { a.bChosen = true });

        this.notifyService.showSuccess('همه خودروها با موفقیت انتخاب شدند');

        this.bSelectAll = true;

      }

      else {

        this.filterCar.forEach((a: any) => { a.bChosen = false });

        this.bSelectAll = false;

      }

    }

    else {

      event.stopPropagation();

      this.filterCar[index].bChosen = event.target?.checked;
    }

  }

  filterSelectOptions(value: string, result: any) {

    var options = '';

    if (value.trim() != '') {

      var filteredOptions = result.filter((el: any) => {

        return el.strComment.trim().includes(value);

      });

      filteredOptions.unshift({ iMobileDomain: -1, strComment: 'انتخاب کنید' });

      filteredOptions.forEach(function (item: any) {

        options += '<option value="' + item.iMobileDomain + '">' + item.strComment + '</option>';

      });

      var selectElement = $('#mySelect');

      selectElement.html(options);

    }

    else {

      result.forEach(function (item: any) {

        options += '<option value="' + item.iMobileDomain + '">' + item.strComment + '</option>';

      });

      var selectElement = $('#mySelect');

      selectElement.html(options);

    }

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this.otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  showAll_Map() {

    if (!this.filterCar.length) return this.notifyService.showError('خودرویی موجود نیست!');

    window.localStorage.setItem("XmeTCrsX5GCZ", this.gurdService.encrypt(JSON.stringify(this.filterCar)));

    window.open('/carList-Tracker', '_blank');


  }

  openPush_User() {

    if (!this.filterCar.length) return this.notifyService.showError('خودرویی موجود نیست!');

    const selectedUser = from(this.filterCar).pipe(filter((el: any) => el?.bChosen && el.bChosen), map((el: any) => el.strUnitID), toArray());

    selectedUser.subscribe(async (data) => {

      const lstUnitID = data;

      if (!lstUnitID.length) return this.notifyService.showError('لیست انتخابی شما خالی می باشد');

      this.mdl_PUSH.patchValue({

        lststrUnitIDs: lstUnitID,

        iPushType: 0,

        bSMS: false

      })

      $('#Push_Modal').modal('show');

    })


  }

  sendPush_4Users = async () => {

    if (this.mdl_PUSH.invalid) return this.notifyService.showError('عنوان را وارد کنید');

    if (this.mdl_PUSH.get('iPushType')?.value == 1 && this.mdl_PUSH.get('strMessage')?.value.trim() == '') return this.notifyService.showError('متن پیام را وارد کنید');

    if (this.mdl_PUSH.get('iPushType')?.value == 2 && this.mdl_PUSH.get('strVoice')?.value == '') return this.notifyService.showError('صدا را ضبط کنید');

    else {

      if (this.mdl_PUSH.get('iPushType')?.value == 2) {

        this.mdl_PUSH.get('strMessage')?.setValue('');

        this.mdl_PUSH.get('tiType')?.setValue('4');

      }

      if (this.mdl_PUSH.get('iPushType')?.value == 1) {

        this.mdl_PUSH.get('strVoice')?.setValue('');

        this.mdl_PUSH.get('tiType')?.setValue('0');

      }

      this.otherService.Showspinner();

      var model = this.otherService.stringNumberToNumber(this.mdl_PUSH.value);

      let response = await axios.post(`SendPush2MobilesSelected`, model);

      this.otherService.nonespinner();

      let res = JSON.parse(response.data.toString())

      if (res.iResult == 0) return this.notifyService.showError(res.strError);

      this.notifyService.showSuccess('پیام با موفقیت ارسال شد');

      this.mdl_PUSH.patchValue({

        lststrUnitIDs: '',

        strTitle: '',

        strMessage: '',

        strVoice: '',

        bSMS: false

      })

      $("#Push_Modal").modal('hide')


    }

  }

  ///AudioHandler

  startAudioRecording() {

    navigator.mediaDevices.getUserMedia({ audio: true })

      .then(stream => {

        if (!this.isAudioRecording) {

          this.isAudioRecording = true;

          this.audioRecordingService.startRecording();

        }

      }).catch(err => {

        if (err.message == "Requested device not found") {

          this.notifyService.showError("سیستم شما دارای میکروفون نمی باشد")

        }

        else {

          alert("خطا در ضبظ صدا")

        }

      })

  }

  abortAudioRecording() {

    if (this.isAudioRecording) {

      this.isAudioRecording = false;

      this.audioRecordingService.abortRecording();

    }

  }

  clearAudioRecordedData() {

    this.mdl_PUSH.get('strVoice')?.setValue('');

    this.audioBlobUrl = null;

    this.audioSrcUrl = '';

    this.notifyService.showSuccess('صدا با موفقیت حذف شد')

  }

  stopAudioRecording() {

    if (this.isAudioRecording) {

      this.audioRecordingService.stopRecording();

      this.isAudioRecording = false;

      this.mdl_PUSH.get('strMessage')?.setValue('');

      this.mdl_PUSH.get('tiType')?.setValue('4');

      this.playAudio();

    }

  }

  blobToBase64(blob: any) {

    return new Promise((resolve, _) => {

      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);

      reader.readAsDataURL(blob);

    });

  }

  isAudioRecorded(): boolean {

    return this.mdl_PUSH.get('strVoice')?.value != '' ? true : false;

  }

  playAudio() {

    setTimeout(() => {

      this.audioSrcUrl = this.sanitizer.bypassSecurityTrustUrl(`data:audio/mp3;base64,` + this.mdl_PUSH.get('strVoice')?.value);

    }, 200);

  }

  async open_AssignModal(event: Event, item: any) {

    event.stopPropagation();

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID,

    }

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_Ready4Trip_ORG_List`, this.otherService.stringNumberToNumber(model))).data);

    this.otherService.nonespinner();

    this.lst_TaxiLon_Driver = res;

    $("#assignModal").modal("show");

  }

  showUpdate_Modal() {

    if (!this.filterCar.length) return this.notifyService.showError('خودرویی موجود نیست!');

    const selectedUser = from(this.filterCar).pipe(filter((el: any) => el?.bChosen && el.bChosen), map((el: any) => el.strUnitID), toArray());

    selectedUser.subscribe(async (data) => {

      const lstUnitID = data;

      if (!lstUnitID.length) return this.notifyService.showError('لیست انتخابی شما خالی می باشد');

      this.mdl_UpdateValidDate.patchValue({

        lststrUnitIDs: lstUnitID,

        iChargingFee: '',

        strValidDate: ''

      })

      $('#Validity_Modal').modal('show');

    })

  }

  submit_Validity = async () => {

    let model = this.mdl_UpdateValidDate.value;

    model.lstUnitID = model.lststrUnitIDs;

    if (model.strValidDate == '' && model.iChargingFee == '') return this.notifyService.showError('ورود یکی از موارد الزامی می باشد');

    if (model.iChargingFee.includes(',')) {

      model.iChargingFee = model.iChargingFee.replace(/,/g, '');

    }

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Mobiles_UpdateMobileValidDateOriChargingFee`, this.otherService.stringNumberToNumber(model))).data);

    this.otherService.nonespinner();

    if (res.iResult == 0) return this.notifyService.showError(res.strError);

    $('#Validity_Modal').modal('hide');

    return this.notifyService.showSuccess('عملیات با موفقیت انجام شد');


  }


}
